import mirrorCreator from "mirror-creator";

export default mirrorCreator(["READ_ALL_CAR_CHATS", "READ_CAR_CHAT", "TOGGLE_FAVORITE_CAR_CHAT"]);
